import { createRef, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  InputBase,
  LinearProgress,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { addDoc, collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import SignaturePad from "react-signature-pad-wrapper";
import {
  BarcodeFormat,
  BrowserMultiFormatReader,
  DecodeHintType,
} from "@zxing/library";
import {
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithPopup,
} from "firebase/auth";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";
import { storage } from "../../services/firebase";
import {
  backButton,
  bodyContainer,
  borderLinearProgress,
  buttonContainer,
  checkBoxText,
  container,
  disclaimerCheckboxContainer,
  disclaimerText,
  informationContainer,
  inputItem,
  itemText,
  legalContainer,
  legalTextContainer,
  matchModalContainer,
  nextButton,
  searchButton,
  searchButtonContainer,
  searchContainer,
  searchInput,
  subContainer,
  termsContainer,
  termsText,
  titleText,
} from "./styles";
import { auth, db, functions } from "../../services/firebase";
import {
  countryList,
  genderList,
  locationList,
  nationalityList,
  populationGroupMenu,
} from "../../constants";
import SelfieImg from "../../assets/imgs/img_selfie.png";
import IdCardImg from "../../assets/imgs/img_id_card.png";
import PassportImg from "../../assets/imgs/img_passport.png";
import WorkPermitImg from "../../assets/imgs/img_permit.png";
import PDPFrontImg from "../../assets/imgs/img_pdp_front.png";
import PDPBackImg from "../../assets/imgs/img_pdp_back.png";
import MatchImg from "../../assets/imgs/img_match.png";
import NotMatchImg from "../../assets/imgs/img_not_match.png";
import SATRNImg from "../../assets/imgs/img_satrn.png";
import { getErrorMessage, showToast } from "../../services/toast";
import { isEmpty, isValidateSAIDNumber, validEmail, validPhone } from "../../utils";
import {
  authButton,
  clearButton,
  divider,
  googleButton,
  input,
  modalContainer,
  saveButton,
  signatureContainer,
} from "../UserInformation/styles";
import { FingerprintsType, ImageType, UserType, FireBaseDataUpdate, FingerprintPictureType, FingerprintPictureLocations } from "../../types";
import { colors } from "../../theme/colors";
import { ReactComponent as GoogleIcon } from "../../assets/icons/ic_google.svg";
import IDCardReader from "../../components/IDCardReader/IDCardReader";
import LoadingView from "../../components/LoadingView/LoadingView";
import ImageUpload from "../../components/ImageUploadView/ImageUpload";
import { FirebaseError } from "firebase/app";

const CriminalCheck = () => {
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [step, setStep] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isDisclaimerChecked, setIsDisclaimerChecked] =
    useState<boolean>(false);
  const [userId, setUserId] = useState<string>("");
  const [isCheckedLegal, setIsCheckedLegal] = useState<boolean>(false);
  const [location, setLocation] = useState<string>("");
  const [foreigner, setForeigner] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [surname, setSurname] = useState<string>("");
  const [birthCountry, setBirthCountry] = useState<string>("");
  const [idNumber, setIdNumber] = useState<string>("");
  const [passportNumber, setPassportNumber] = useState<string>("");
  const [passportCountry, setPassportCountry] = useState<string>("");
  const [satrnNumber, setSatrnNumber] = useState<string>("");
  const [birthday, setBirthday] = useState<string>("");
  const [nationality, setNationality] = useState<string>("");
  const [populationGroup, setPopulationGroup] = useState<string>("");
  const [gender, setGender] = useState<string>("");
  const [signatureOpen, setSignatureOpen] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>("");
  const [selfieSrc, setSelfieSrc] = useState<string>("");
  const [idCardSrc, setIdCardSrc] = useState<string>("");
  const [passportSrc, setPassportSrc] = useState<string>("");
  const [satrnSrc, setSATRNSrc] = useState<string>("");
  const [workPermitSrc, setWorkPermitSrc] = useState<string>("");
  const [licenseFrontSrc, setLicenseFrontSrc] = useState<string>("");
  const [licenseBackSrc, setLicenseBackSrc] = useState<string>("");
  const [cardScannerOpen, setCardScannerOpen] = useState<boolean>(false);
  const [signatureSrc, setSignatureSrc] = useState<string>("");
  const [signatureData, setSignatureData] = useState<string>("");
  const [isScaned, setIsScaned] = useState<boolean>(false);
  const [detectCount, setDetectCount] = useState<number>(0);
  const [isSigned, setIsSigned] = useState<boolean>(false);
  const [latitude, setLatitude] = useState<number | null>(null);
  const [longitude, setLongitude] = useState<number | null>(null);
  const [fingerprintId, setFingerprintId] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [userEmail, setUserEmail] = useState<string>("");
  const [criminalCheckEmail, setCriminalCheckEmail] = useState<string>("");
  const [criminalCheckPhoneNumber, setCriminalCheckPhoneNumber] = useState<string>("");
  const [confirmEmail, setConfirmEmail] = useState<string>("");
  const [password, setPassowrd] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [userPhoneNumber, setUserPhoneNumber] = useState<string>("");
  const [isFound, setIsFound] = useState<boolean>(false);
  const [openFound, setOpenFound] = useState<boolean>(false);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const currentId = params.get("id");
  const currentStep = params.get("currentStep");
  const [basePicturePath, setBasePicturePath] = useState<string>("");

  const signaturePadRef = createRef<SignaturePad>();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });

  const hints = new Map();
  const formats = [
    BarcodeFormat.AZTEC,
    BarcodeFormat.CODABAR,
    BarcodeFormat.CODE_39,
    BarcodeFormat.CODE_93,
    BarcodeFormat.CODE_128,
  ];
  hints.set(DecodeHintType.PURE_BARCODE, formats);
  const codeReader = new BrowserMultiFormatReader(hints);
  // const codeReader = new BrowserMultiFormatReader();

  const informationText = [
    "1) Identification document",
    "2) PrDP",
    "3) Driver’s license",
    "4) No hats, sunglasses, etc.",
    "5) 5MB camera",
    "6) Enough light - no night pictures",
  ];

  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setUserId(uid);
        setIsLogin(true);
      } else {
        console.log("user is logged out");
      }
    });
    getUserlocation();
  }, []);

  useEffect(() => {
    let tempStep = localStorage.getItem("step");
    if (tempStep === "1") {
      setStep(1);
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(fingerprintId) && step !== 0) {
      navigate(`/criminal?id=${fingerprintId}&currentStep=${step}`);
    } else {
      if (step > 1) {
        navigate(`/criminal?id=${currentId}&currentStep=${step}`);
      }
    }
  }, [step, currentId, fingerprintId]);

  useEffect(() => {
    //console.log(`User id changed to: ${userId} insp: ${inspectId} ${!inspectId} curr: ${currentId} ${!currentId}`);
    if (userId && !fingerprintId && (!currentId || currentId === 'null')) {
      console.log('creating record');
      addUserFingerPrintsData()
    };
  }, [userId, fingerprintId, currentId])

  useEffect(() => {
    if (!isEmpty(userId) && currentId) {
      getFingerPrint();
    }
  }, [userId, currentId]);

  useEffect(() => {
    setBasePicturePath(`users/${userId}/fingerprintPictures/${fingerprintId}`);
  }, [userId, fingerprintId]);

  const getFingerPrint = async () => {
    setIsLoading(true);
    const docRef = doc(
      db,
      `users/${userId}/fingerprints/${!isEmpty(fingerprintId) ? fingerprintId : currentId
      }`
    );
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      let one = docSnap.data() as FingerprintsType;
      setSignatureSrc(one.clientSignature?.url || "");
      setLocation(one.location || "");
      setForeigner(false); // fix when restoring foreigner
      setName(one.name || "");
      setSurname(one.surname || "");
      setCriminalCheckEmail(one.emailAddress || userEmail || "");
      setCriminalCheckPhoneNumber(one.phoneNumber || userPhoneNumber || "");
      setBirthCountry(one.birthCountry || "");
      setIdNumber(!one.usePassport ? one.idOrPassport || "" : "");
      setPassportNumber(one.usePassport ? one.idOrPassport || "" : "");
      setPassportCountry(one.passportCountry || "");
      setSatrnNumber(one?.satrnNumber || "");
      setBirthday(one.birthday || "");
      setNationality(one.nationality || "");
      setPopulationGroup(one.populationGroup || "");
      setGender(one.gender || "");
      setSelfieSrc(one.pictureOfSelf?.url || "");
      setIdCardSrc(one.pictureOfID?.url || "");
      setPassportSrc(one.pictureOfPassport?.url || "");
      setSATRNSrc(one.pictureOfSATRNCertificate?.url || "");
      setWorkPermitSrc(one.pictureOfWorkPermit?.url || "");
      setLicenseFrontSrc(one.pictureOfPDPFront?.url || "");
      setLicenseBackSrc(one.pictureOfPDPBack?.url || "");
      setStep(currentStep ? parseInt(currentStep) : 0);
      setFingerprintId(currentId || "");
      setIsLoading(false);

      if (one.paid) {
        showToast('Already paid');
        navigate(`/`);
      }
    } else {
      // docSnap.data() will be undefined in this case
      console.log("No such document!");
      setIsLoading(false);
    }
  };

  const getUserlocation = () => {
    if ("geolocation" in navigator) {
      // Prompt user for permission to access their location
      navigator.geolocation.getCurrentPosition(
        // Success callback function
        (position) => {
          // Get the user's latitude and longitude coordinates
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          // Do something with the location data, e.g. display on a map
          setLatitude(lat);
          setLongitude(lng);
        },
        // Error callback function
        (error) => {
          // Handle errors, e.g. user denied location sharing permissions
          console.error("Error getting user location:", error);
        }
      );
    } else {
      // Geolocation is not supported by the browser
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const addUserData = async (uid: string) => {
    setIsLoading(true);
    try {
      let userData: UserType = {
        uid: uid,
        email: userEmail,
        name: firstName,
        surname: lastName,
        phoneNumber: userPhoneNumber,
      };
      const docRef = await updateDoc(doc(db, `users/${uid}`), userData as FireBaseDataUpdate);
      console.log(docRef);
      setIsLoading(false);
      setStep((preStep) => preStep + 1);
    } catch (e) {
      setIsLoading(false);
      showToast("Something went long", "error");
    }
  };

  const onCreateUser = async () => {
    setIsLoading(true);
    await createUserWithEmailAndPassword(auth, userEmail, password)
      .then((userCredential) => {
        const user = userCredential.user;
        setUserId(user.uid);
        addUserData(user.uid);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        const errorCode = error.code;
        const errorMessage = getErrorMessage(errorCode);
        showToast(errorMessage, "error");
      });
  };

  const onGoogleLogin = () => {
    signInWithPopup(auth, provider)
      .then(async (result) => {
        setIsLoading(false);
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.accessToken;
        const user = result.user;
        let userData: UserType = {
          uid: result.user.uid,
          email: user.email ? user.email : "",
          name: user.displayName?.split(" ")[0],
          surname: user.displayName?.split(" ")[1],
          phoneNumber: user.phoneNumber || "",
        };
        await updateDoc(doc(db, `users/${user.uid}`), userData as FireBaseDataUpdate);
        setUserId(user.uid);
        setUserEmail(user.email ? user.email : "");
        setFirstName(user.displayName?.split(" ")[0] || "");
        setLastName(user.displayName?.split(" ")[1] || "");
        setUserPhoneNumber(user.phoneNumber || "");
        // setStep((preStep) => preStep + 1);
      })
      .catch((error) => {
        setIsLoading(false);
        const errorMessage = error.message;
        showToast(errorMessage, "error");
      });
  };

  const handleNext = () => {
    localStorage.clear();
    if (step === 0) {
      if (!isChecked) {
        showToast("Please check information", "error");
        return;
      }
      setStep((preStep) => preStep + 1);
    } else if (step === 1) {
      if (!isLogin) {
        if (isEmpty(firstName)) {
          showToast("Please input your first name", "error");
          return;
        }
        if (isEmpty(lastName)) {
          showToast("Please input your last name", "error");
          return;
        }
        if (isEmpty(userEmail)) {
          showToast("Please input your email address", "error");
          return;
        }
        if (!validEmail(userEmail)) {
          showToast("Your email address in invalid", "error");
          return;
        }
        if (isEmpty(confirmEmail)) {
          showToast("Please confirm your email address", "error");
          return;
        }
        if (isEmpty(password)) {
          showToast("Please input your password", "error");
          return;
        }
        if (isEmpty(confirmPassword)) {
          showToast("Please confirm your password", "error");
          return;
        }
        if (isEmpty(userPhoneNumber)) {
          showToast("Please input your phone number", "error");
          return;
        }
        if (!validPhone(userPhoneNumber)) {
          showToast("Phone number should be 10 digits", "error");
          return;
        }
        if (userEmail !== confirmEmail) {
          showToast(
            "The email address is not matched with your confirm email adress",
            "error"
          );
          return;
        }
        if (password !== confirmPassword) {
          showToast(
            "The password is not matched with your confirm password.",
            "error"
          );
          return;
        }
        onCreateUser();
      } else {
        if (isEmpty(signatureData)) {
          showToast("You have to sign the legal and consent.", "error");
          return;
        }
        if (!isCheckedLegal) {
          showToast(
            "You have to check the information and accept the legal and consent",
            "error"
          );
          return;
        }
        updateUserFingerPrintsData();
        uploadSignature()
      }
    } else if (step === 2) {
      if (!isDisclaimerChecked) {
        showToast(
          "You have to check and accept the fingerprint disclaimer.",
          "error"
        );
        return;
      }
      setStep((preStep) => preStep + 1);
    } else if (step === 3) {
      if (isEmpty(location)) {
        showToast("Please select the location.", "error");
        return;
      }
      if (isEmpty(name)) {
        showToast("Please input the name.", "error");
        return;
      }
      if (isEmpty(surname)) {
        showToast("Please input the surname.", "error");
        return;
      }
      if (isEmpty(criminalCheckEmail)) {
        showToast("Please input the email.", "error");
        return;
      }
      if (!validEmail(criminalCheckEmail)) {
          showToast("Your email address in invalid", "error");
          return;
        }
      if (isEmpty(criminalCheckPhoneNumber)) {
        showToast("Please input the phone number.", "error");
        return;
      }
      if (!validPhone(criminalCheckPhoneNumber)) {
          showToast("Phone number should be 10 digits", "error");
          return;
        }
      if (isEmpty(birthCountry)) {
        showToast("Please select the country of birth.", "error");
        return;
      }
      if (foreigner) {
        showToast("Foreigner disabled", "error");
        return;
        if (isEmpty(passportNumber)) {
          showToast("Please input the passport number.", "error");
          return;
        }
        if (isEmpty(passportCountry)) {
          showToast("Please select the passport country.", "error");
          return;
        }
        if (isEmpty(satrnNumber)) {
          showToast("Please input the SATRN number.", "error");
          return;
        }
      } else {
        if (isEmpty(idNumber)) {
          showToast("Please input the id card number.", "error");
          return;
        }
        if (!isValidateSAIDNumber(idNumber)) {
          showToast("Your ID card number is not correct.", "error");
          return;
        }
      }

      if (isEmpty(birthday)) {
        showToast("Please select the birthday.", "error");
        return;
      }
      if (isEmpty(nationality)) {
        showToast("Please select the nationality.", "error");
        return;
      }
      if (isEmpty(populationGroup)) {
        showToast("Please select the population group.", "error");
        return;
      }
      if (isEmpty(gender)) {
        showToast("Please select the gender.", "error");
        return;
      }
      updateUserFingerPrintsData();
    } else if (step === 4) {
      if (foreigner) {
        showToast("Foreigner disabled", "error");
        return;
        if (isEmpty(selfieSrc)) {
          showToast("Please take a photo of selfie.", "error");
          return;
        }
        if (isEmpty(passportSrc)) {
          showToast("Please take a photo of passport.", "error");
          return;
        }
        if (isEmpty(workPermitSrc)) {
          showToast("Please take a photo of work permit.", "error");
          return;
        }
      } else {
        if (isEmpty(selfieSrc)) {
          showToast("Please take a photo of selfie.", "error");
          return;
        }
        if (isEmpty(idCardSrc)) {
          showToast("Please take a photo of ID card.", "error");
          return;
        }
      }
      updateUserFingerPrintsData();
    } else if (step === 5) {
      if (isEmpty(licenseFrontSrc)) {
        showToast("Please take a photo of PDP/License front.", "error");
        return;
      }
      if (isEmpty(licenseBackSrc)) {
        showToast("Please take a photo of PDP/License back.", "error");
      }
      updateUserFingerPrintsData();
    } else {
      console.log(step);
    }
  };

  const getImageData = (image: string, type: string, size: number = 50000) => {
    let imageData: ImageType = {
      basePath: basePicturePath,
      createdAt: new Date(),
      name: `${type}/${Date.now()}`,
      size: size,
      thumbUrl: image,
      type: "image/png",
      url: image,
      exifdata: {
        BrowserLocation: {
          lat: latitude,
          lng: longitude,
        },
        MakerNote: "",
      },
    };
    return imageData;
  };

  const addUserFingerPrintsData = async () => {
    let fingerprintsData: FingerprintsType = {
      uid: fingerprintId,
      createdBy: userId,
      paid: false,
      date: new Date().getTime(),
      redo: {},
      state: "Unpaid",
      name: name,
      surname: surname,
      phoneNumber: criminalCheckPhoneNumber,
      emailAddress: criminalCheckEmail,
      location: location,
      idOrPassport: !foreigner ? idNumber : passportNumber,
      birthCountry: birthCountry,
      passportCountry: passportCountry,
      satrnNumber: satrnNumber,
      usePassport: foreigner,
      birthday: birthday,
      nationality: nationality,
      populationGroup: populationGroup,
      gender: gender,
      finished: false,
    };
    const docRef = await addDoc(
      collection(db, `users/${userId}/fingerprints`),
      fingerprintsData
    );
    setFingerprintId(docRef.id);
    console.log('Added', docRef.id)
  };

  const updateUserFingerPrintsData = async () => {
    console.log('update');
    let updateData: FingerprintsType = {
      uid: fingerprintId,
      createdBy: userId,
      paid: false,
      date: new Date().getTime(),
      redo: {},
      state: "Unpaid",
      name: name,
      surname: surname,
      phoneNumber: criminalCheckPhoneNumber,
      emailAddress: criminalCheckEmail,
      location: location,
      idOrPassport: !foreigner ? idNumber : passportNumber,
      birthCountry: birthCountry,
      passportCountry: passportCountry,
      satrnNumber: satrnNumber,
      usePassport: foreigner,
      birthday: birthday,
      nationality: nationality,
      populationGroup: populationGroup,
      gender: gender,
      finished: step === 5 ? true : false,
    };
    console.log(`users/${userId}/fingerprints/${fingerprintId}`);
    const docRef = await updateDoc(
      doc(db, `users/${userId}/fingerprints/${fingerprintId}`),
      updateData as FireBaseDataUpdate
    );
    console.log("updated", docRef)
    if (step < 5) {
      setStep((preStep) => preStep + 1);
    } else if (step === 5) {
      navigate(`/fingerprintPayment/${fingerprintId}`);
    } else {
      console.log(step);
    }
  };

  const handleSearch = () => {
    if (isEmpty(searchText)) {
      showToast("Please input ID or Passport Number.", "error");
      return;
    }
    setIsLoading(true);
    setOpenFound(true);
    const searchFingerprints = httpsCallable(functions, "searchFingerprints");
    searchFingerprints({
      idOrPassport: searchText,
    })
      .then((result: any) => {
        result.data.status === "Found" ? setIsFound(true) : setIsFound(false);
        setSearchText("");
        setIsLoading(false);
      })
      .catch((error) => {
        if (error instanceof FirebaseError) {
          showToast((error as FirebaseError).message, "error");
        } else {
          showToast("Unknown error", "error");
        }
        setIsLoading(false);
      });
  };

  const handleScannerClose = () => {
    setCardScannerOpen(false);
  };

  const handleMatchModalClose = () => {
    setOpenFound(false);
  };

  const handleSignatureClose = () => {
    setSignatureOpen(false);
  };

  const handleClear = () => {
    const signaturePad = signaturePadRef.current;
    if (signaturePad) {
      signaturePad.instance.clear();
    }
  };

  const handleSave = async () => {
    const signaturePad = signaturePadRef.current;
    if (!signaturePad) {
      return;
    }
    if (signaturePad.isEmpty()) {
      showToast("Please provide a signature first.", "error");
    } else {
      setSignatureData(signaturePad.toDataURL());
      setIsSigned(true);
      setSignatureOpen(false);
    }
  };

  const uploadSignature = async () => {

    setIsLoading(true);

    const signaturURI = signatureData

    const imageRef = storageRef(
      storage,
      `${basePicturePath}/clientSignature.png`
    );
    const binaryVal = atob(signaturURI.split(',')[1]);

    // Store the bytes of the string to a typed array
    var blobArray = [];
    for (var index = 0; index < binaryVal.length; index++) {
      blobArray.push(binaryVal.charCodeAt(index));
    }

    await uploadBytes(imageRef, new Blob([new Uint8Array(blobArray)]))
    const url = await getDownloadURL(imageRef);
    // console.log(url)
    // {todo} Upload the signature instead of getting the data url 
    setSignatureSrc(url);
    await uploadImage(getImageData(url, 'clientSignature', blobArray.length), FingerprintPictureType.clientSignature)


    setIsLoading(false);

  };

  const uploadImage = async (imageData: ImageType, type: FingerprintPictureType) => {
    setIsLoading(true)
    const imageKey = FingerprintPictureLocations[type]
    if (!imageKey) { return }
    let fingerprintData: Partial<FingerprintsType> = {}

    fingerprintData[imageKey] = imageData;

    // console.log(`Updating document  users/${userId}/inspections/${!isEmpty(inspectId) ? inspectId : currentId}`)
    await updateDoc(
      doc(
        db,
        `users/${userId}/fingerprints/${!isEmpty(fingerprintId) ? fingerprintId : currentId
        }`
      ),
      fingerprintData
    );
    setIsLoading(false)

  }

  const signup = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <TextField
        placeholder="First Name"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={firstName}
        onChange={(e) => setFirstName(e.target.value)}
      />
      <TextField
        placeholder="Last Name"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => input(theme)}
        value={lastName}
        onChange={(e) => setLastName(e.target.value)}
      />
      <TextField
        placeholder="Email Address"
        size="small"
        fullWidth
        type="email"
        required
        sx={(theme) => input(theme)}
        value={userEmail}
        onChange={(e) => setUserEmail(e.target.value)}
      />
      <TextField
        placeholder="Confirm Email Address"
        size="small"
        fullWidth
        type="email"
        required
        sx={(theme) => input(theme)}
        value={confirmEmail}
        onChange={(e) => setConfirmEmail(e.target.value)}
      />
      <TextField
        placeholder="Password"
        size="small"
        fullWidth
        type="password"
        required
        sx={(theme) => input(theme)}
        value={password}
        onChange={(e) => setPassowrd(e.target.value)}
      />
      <TextField
        placeholder="Confirm Password"
        size="small"
        fullWidth
        type="password"
        required
        sx={(theme) => input(theme)}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      <TextField
        placeholder="Cellphone Number"
        size="small"
        fullWidth
        type="tel"
        required
        sx={(theme) => input(theme)}
        value={userPhoneNumber}
        onChange={(e) => setUserPhoneNumber(e.target.value)}
      />

      <Divider sx={(theme) => divider(theme)}>or</Divider>

      <Button
        fullWidth
        variant="contained"
        sx={(theme) => authButton(theme)}
        onClick={() => {
          localStorage.setItem("step", "1");
          localStorage.setItem("from", "dcc");
          navigate("/login");
        }}
      >
        Existing User
      </Button>

      <Divider sx={(theme) => divider(theme)}>or continue with</Divider>

      <Button
        fullWidth
        variant="contained"
        startIcon={<GoogleIcon />}
        sx={(theme) => googleButton(theme)}
        onClick={() => {
          onGoogleLogin();
        }}
      >
        Google
      </Button>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "12px",
          color: colors.dark_gray,
          mt: 2,
        }}
      >
        By clicking continue, you agree to our{" "}
        <b style={{ color: "black" }}>Terms of Service</b> and{" "}
        <b style={{ color: "black" }}>Privacy Policy</b>
      </Typography>
    </Box>
  );

  const information = (
    <Box>
      <Box sx={(theme) => informationContainer(theme)}>
        <Typography sx={(theme) => itemText(theme)}>
          Please ensure you have the following before starting:
        </Typography>
        {informationText.map((one, index) => {
          return (
            <Typography sx={(theme) => itemText(theme)} key={index}>
              {one}
            </Typography>
          );
        })}
      </Box>
      <Box sx={(theme) => termsContainer(theme)}>
        <Typography sx={(theme) => termsText(theme)}>
          I have read and understood the information above
        </Typography>
        <Checkbox
          checked={isChecked}
          onChange={() => setIsChecked(!isChecked)}
        />
      </Box>
    </Box>
  );

  const legalView = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <Box sx={(theme) => legalContainer(theme)}>
        <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
          12 Consent Form Templates to Always Have on Hand When Doing Business
        </Typography>
        <Typography variant="body2">
          When running a business, you need a number of legal documents in your
          arsenal. Having the right legal documentation is critical for ensuring
          compliance with applicable laws and regulations. They also protect
          your business's interests, shielding it from potential legal issues
          like lawsuits, penalties, hefty fines and fees. One essential legal
          document most businesses often neglect is consent forms. Consent forms
          are used to legally obtain permission to perform certain actions,
          ensuring that all parties involved fully understand the terms and
          conditions of the agreement. Maybe you're wondering how consent forms
          might come into play in your business and how to create them properly.
          This article will explore everything you need to know about consent
          forms. We’ve also included 12 consent form templates you should have
          on hand while doing business. Before we dive in, here’s a short
          selection of 8 easy-to-edit consent form templates you can edit, share
          and download with Visme. View more templates below:
        </Typography>
        <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
          What Is a Consent Form?
        </Typography>
        <Typography variant="body2">
          A consent form is a document used to obtain permission from an
          individual or parties to perform certain actions or engage in
          activities. The form indicates that the signatory understands the
          associated terms and cannot hold the other party liable for any injury
          or harm. The purpose of a consent form is to: Inform individuals or
          parties about a particular activity or procedure. Ensure that
          participants are fully aware of the risks and benefits associated with
          a particular activity or procedure. Obtain their voluntary agreement
          or consent to participate in it. Provide them with the opportunity to
          ask questions before deciding whether or not to participate. Consent
          forms are useful in business, marketing, finance, law, psychology,
          social sciences and education. Also, they are commonly used in medical
          research, clinical trials, and other healthcare-related activities.
        </Typography>
        <Typography variant="h5" sx={{ mt: 2, mb: 1 }}>
          The Importance of Using a Consent Form
        </Typography>
        <Typography variant="body2">
          A consent form is a document used to obtain permission from an
          individual or parties to perform certain actions or engage in
          activities. The form indicates that the signatory understands the
          associated terms and cannot hold the other party liable for any injury
          or harm. The purpose of a consent form is to: Inform individuals or
          parties about a particular activity or procedure. Ensure that
          participants are fully aware of the risks and benefits associated with
          a particular activity or procedure. Obtain their voluntary agreement
          or consent to participate in it. Provide them with the opportunity to
          ask questions before deciding whether or not to participate. Consent
          forms are useful in business, marketing, finance, law, psychology,
          social sciences and education. Also, they are commonly used in medical
          research, clinical trials, and other healthcare-related activities.
        </Typography>
      </Box>
      <Box sx={(theme) => signatureContainer(theme)}>
        {!isSigned && (
          <Button
            variant="contained"
            sx={(theme) => backButton(theme)}
            onClick={() => {
              setSignatureOpen(true);
            }}
          >
            SIGN
          </Button>
        )}
        {isSigned && (
          <img
            src={signatureSrc || signatureData}
            alt="signaure"
            width={300}
            style={{ objectFit: "contain" }}
          />
        )}
      </Box>
      <Box sx={(theme) => legalTextContainer(theme)}>
        <Typography sx={(theme) => checkBoxText(theme)}>
          I have read and understood the information and accept above
        </Typography>
        <Checkbox
          checked={isCheckedLegal}
          onChange={(e) => setIsCheckedLegal(!isCheckedLegal)}
        />
      </Box>
    </Box>
  );

  const disclaimerView = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <Box sx={{ mx: 4 }}>
        <Typography sx={(theme) => disclaimerText(theme)}>
          Please note that it is required that your physical fingerprints have
          been taken before.
        </Typography>
        <Typography sx={(theme) => disclaimerText(theme)}>
          This service is only available to persons with a valid South African ID
          Document.
        </Typography>
        <Typography sx={(theme) => disclaimerText(theme)}>
          If they have not then please visit a centre of your choice to conduct
          a criminal background check.
        </Typography>
        <Typography sx={(theme) => disclaimerText(theme)}>
          You may search RaspberryONE for a match.
        </Typography>
      </Box>
      <Box sx={(theme) => searchContainer(theme)}>
        <SearchIcon color="disabled" />
        <InputBase
          placeholder="South African ID number"
          sx={(theme) => searchInput(theme)}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Box>
      <Box sx={(theme) => searchButtonContainer(theme)}>
        <Button
          variant="contained"
          sx={(theme) => searchButton(theme)}
          onClick={() => handleSearch()}
        >
          Search
        </Button>
      </Box>
      <Box sx={(theme) => disclaimerCheckboxContainer(theme)}>
        <Typography sx={(theme) => termsText(theme)}>
          I have read and understood the information above
        </Typography>
        <Checkbox
          checked={isDisclaimerChecked}
          onChange={() => setIsDisclaimerChecked(!isDisclaimerChecked)}
        />
      </Box>
    </Box>
  );

  const criminalCheckView = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <Select
        labelId="location-select-label"
        id="locaiton-select"
        value={location}
        onChange={(event) => setLocation(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white" }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Location
              </em>
            );
          }

          return selected;
        }}
      >
        {locationList.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>

      <TextField
        placeholder="Name(s)"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => inputItem(theme)}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <TextField
        placeholder="Surname"
        size="small"
        fullWidth
        type="text"
        required
        sx={(theme) => inputItem(theme)}
        value={surname}
        onChange={(e) => setSurname(e.target.value)}
      />
      <TextField
        placeholder="Email"
        size="small"
        fullWidth
        type="email"
        required
        sx={(theme) => inputItem(theme)}
        value={criminalCheckEmail}
        onChange={(e) => setCriminalCheckEmail(e.target.value)}
      />
      <TextField
        placeholder="Cellphone number"
        size="small"
        fullWidth
        type="tel"
        required
        sx={(theme) => inputItem(theme)}
        value={criminalCheckPhoneNumber}
        onChange={(e) => setCriminalCheckPhoneNumber(e.target.value)}
      />
      
      <Select
        labelId="birth-country-select-label"
        id="birth-country-select"
        value={birthCountry}
        onChange={(event) => setBirthCountry(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Country of Birth
              </em>
            );
          }

          return selected;
        }}
      >
        { Object.keys(countryList).map((country) => {
          return (
            <MenuItem value={(countryList as any)[country]} key={(countryList as any)[country]}>
              {(countryList as any)[country]}
            </MenuItem>
          );
        })}
      </Select>
      {!foreigner && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <TextField
            placeholder="South African ID Number"
            size="small"
            fullWidth
            type="number"
            required
            sx={(theme) => inputItem(theme)}
            value={idNumber}
            onChange={(e) => setIdNumber(e.target.value)}
          />
          <Button
            variant="contained"
            sx={{ mt: 1, ml: 1 }}
            onClick={() => {
              setCardScannerOpen(true);
            }}
          >
            Scan
          </Button>
        </Box>
      )}
      {foreigner && (
        <TextField
          placeholder="Passport Number"
          size="small"
          fullWidth
          type="text"
          required
          sx={(theme) => inputItem(theme)}
          value={passportNumber}
          onChange={(e) => setPassportNumber(e.target.value)}
        />
      )}
      {foreigner && ( <Select
        labelId="passport-country-select-label"
        id="passport-country-select"
        value={passportCountry}
        onChange={(event) => setPassportCountry(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Passport Country
              </em>
            );
          }

          return (countryList as any)[selected];
        }}
      >
        { Object.keys(countryList).map((country) => {
          return (
            <MenuItem value={country} key={country}>
              {(countryList as any)[country]}
            </MenuItem>
          );
        })}
      </Select>)}
      {foreigner && (
        <TextField
          placeholder="SATRN number"
          size="small"
          fullWidth
          type="text"
          required
          sx={(theme) => inputItem(theme)}
          value={satrnNumber}
          onChange={(e) => setSatrnNumber(e.target.value)}
        />
      )}
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box
          sx={{
            backgroundColor: "white",
            py: "6px",
            px: "12px",
            minWidth: "100px",
            borderRadius: 1,
            mt: 1,
            mr: 1,
          }}
        >
          <Typography sx={{ color: "rgb(169, 169, 169)", fontSize: "16px" }}>
            Date of Birth:
          </Typography>
        </Box>
        <TextField
          placeholder="Date of Birth"
          size="small"
          fullWidth
          type="date"
          required
          sx={(theme) => inputItem(theme)}
          value={birthday}
          onChange={(e) => setBirthday(e.target.value)}
        />
      </Box>

      <Select
        labelId="nationality-select-label"
        id="nationality-select"
        value={nationality}
        onChange={(event) => setNationality(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Nationality
              </em>
            );
          }

          return selected;
        }}
      >
        {nationalityList.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
      <Select
        labelId="ethnicity-select-label"
        id="ethnicity-select"
        value={populationGroup}
        onChange={(event) => setPopulationGroup(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>
                Population Group
              </em>
            );
          }

          return selected;
        }}
      >
        {populationGroupMenu.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
      <Select
        labelId="gender-select-label"
        id="gender-select"
        value={gender}
        onChange={(event) => setGender(event.target.value)}
        size="small"
        sx={{ width: "100%", bgcolor: "white", mt: 1 }}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return (
              <em style={{ color: "#a9a9a9", fontStyle: "normal" }}>Gender</em>
            );
          }

          return selected;
        }}
      >
        {genderList.map((one, index) => {
          return (
            <MenuItem value={one} key={index}>
              {one}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );

  const idCardView = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={SelfieImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.selfie]}
        pictureType={FingerprintPictureType.selfie}
        imageSrc={selfieSrc}
        title="Selfie"
        updateSrc={setSelfieSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="user"

      ></ImageUpload>
      <ImageUpload
        defaultImageSrc={IdCardImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.id]}
        pictureType={FingerprintPictureType.id}
        imageSrc={idCardSrc}
        title="Identification document (ID)"
        updateSrc={setIdCardSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

    </Box>
  );

  const foreginerView = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={SelfieImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.selfie]}
        pictureType={FingerprintPictureType.selfie}
        imageSrc={selfieSrc}
        title="Selfie"
        updateSrc={setSelfieSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="user"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={PassportImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.passport]}
        pictureType={FingerprintPictureType.passport}
        imageSrc={passportSrc}
        title="Passport"
        updateSrc={setPassportSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={SATRNImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.SATRNCertificate]}
        pictureType={FingerprintPictureType.SATRNCertificate}
        imageSrc={satrnSrc}
        title="SATRN"
        updateSrc={setSATRNSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>




      <ImageUpload
        defaultImageSrc={WorkPermitImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.workPermit]}
        pictureType={FingerprintPictureType.workPermit}
        imageSrc={workPermitSrc}
        title="Work Permit"
        updateSrc={setWorkPermitSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>
      
    </Box>
  );

  const pdpView = (
    <Box sx={{ width: "100%", p: "20px 0" }}>
      <ImageUpload
        defaultImageSrc={PDPFrontImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.PDPFront]}
        pictureType={FingerprintPictureType.PDPFront}
        imageSrc={licenseFrontSrc}
        title="PDP / License Front"
        updateSrc={setLicenseFrontSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

      <ImageUpload
        defaultImageSrc={PDPBackImg}
        webcamType={FingerprintPictureType[FingerprintPictureType.PDPBack]}
        pictureType={FingerprintPictureType.PDPBack}
        imageSrc={licenseBackSrc}
        title="PDP / License back"
        updateSrc={setLicenseBackSrc}

        basePath={basePicturePath}


        longitude={longitude} latitude={latitude}
        saveImage={uploadImage}
        capture="environment"

      ></ImageUpload>

    </Box>
  );

  return (
    <Box sx={(theme) => container(theme)}>
      <Box sx={(theme) => bodyContainer(theme)}>
        {!isLogin && (
          <Box sx={(theme) => subContainer(theme)}>
            <Typography sx={(theme) => titleText(theme)}>
              {step === 0
                ? "Information"
                : step === 1
                  ? "User Information"
                  : step === 2
                    ? "Vehicle Information"
                    : step === 3
                      ? "Documents"
                      : step === 4
                        ? "Documents"
                        : ""}
            </Typography>
            {step === 0 && information}
            {step === 1 && signup}

            <Box sx={(theme) => buttonContainer(theme)}>
              <Button
                variant="contained"
                sx={(theme) => backButton(theme)}
                onClick={() => {
                  if (step === 0) {
                    navigate("/services");
                  } else {
                    setStep((preStep) => preStep - 1);
                  }
                }}
              // disabled={step < 1}
              >
                Back
              </Button>

              <Button
                variant="contained"
                sx={(theme) => nextButton(theme)}
                onClick={() => handleNext()}
                disabled={isLoading}
              >
                Next
              </Button>
            </Box>
            <LinearProgress
              value={step === 0 ? 0 : (100 / 7) * step}
              variant="determinate"
              sx={(theme) => borderLinearProgress(theme)}
            />
          </Box>
        )}
        {isLogin && (
          <Box sx={(theme) => subContainer(theme)}>
            <Typography sx={(theme) => titleText(theme)}>
              {step === 0
                ? "Information"
                : step === 1
                  ? "Legal and Consent"
                  : step === 2
                    ? "Fingerprint Disclaimer"
                    : step === 3
                      ? "Criminal Check Information"
                      : step === 4 || step === 5 || step === 6
                        ? "Documents"
                        : ""}
            </Typography>
            {step === 0 && information}
            {step === 1 && legalView}
            {step === 2 && disclaimerView}
            {step === 3 && criminalCheckView}
            {step === 4 && foreigner && foreginerView}
            {step === 4 && !foreigner && idCardView}
            {step === 5 && pdpView}

            <Box sx={(theme) => buttonContainer(theme)}>
              <Button
                variant="contained"
                sx={(theme) => backButton(theme)}
                onClick={() => {
                  if (step === 0) {
                    navigate("/services");
                  } else {
                    setStep((preStep) => preStep - 1);
                  }
                }}
              >
                Back
              </Button>

              <Button
                variant="contained"
                sx={(theme) => nextButton(theme)}
                onClick={() => handleNext()}
              >
                {"Next"}
                {isLoading && (
                  <CircularProgress size={30} sx={{ ml: 1, color: "white" }} />
                )}
              </Button>
            </Box>
            <LinearProgress
              value={step === 0 ? 0 : (100 / 6) * step}
              variant="determinate"
              sx={(theme) => borderLinearProgress(theme)}
            />
          </Box>
        )}
      </Box>
      <Modal
        open={cardScannerOpen}
        onClose={handleScannerClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={(theme) => modalContainer(theme)}>
          <IDCardReader
            setBarCode={setIdNumber}
            setOpen={setCardScannerOpen}
            setDetectCount={setDetectCount}
            setIsScaned={setIsScaned}
            codeReader={codeReader}
          />
        </Box>
      </Modal>
      <Modal
        open={signatureOpen}
        onClose={handleSignatureClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={(theme) => modalContainer(theme)}>
          <SignaturePad
            ref={signaturePadRef}
            height={250}
            options={{
              minWidth: 1,
              maxWidth: 1,
              penColor: "black",
            }}
            debounceInterval={1}
            redrawOnResize
          />
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Button
              variant="contained"
              sx={(theme) => clearButton(theme)}
              onClick={() => handleClear()}
            >
              Clear
            </Button>
            <Button
              variant="contained"
              sx={(theme) => saveButton(theme)}
              onClick={() => handleSave()}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={openFound}
        onClose={handleMatchModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={(theme) => matchModalContainer(theme)}>
          {isLoading ? (
            <CircularProgress size={70} sx={{ m: 2, color: colors.main }} />
          ) : (
            <Box sx={{ m: 2 }}>
              <img
                src={isFound ? MatchImg : NotMatchImg}
                style={{
                  height: "80px",
                  width: "100%",
                  objectFit: licenseBackSrc === "" ? "contain" : "cover",
                }}
                alt="match result"
              />
              <Typography
                sx={{
                  color: colors.light_black,
                  fontSize: "18px",
                  fontWeight: "bold",
                  mt: 1,
                }}
              >
                {isFound ? "MATCH FOUND!" : "NO MATCH!"}
              </Typography>
            </Box>
          )}
        </Box>
      </Modal>
      {isLoading && <LoadingView />}
    </Box>
  );
};

export default CriminalCheck;
